import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import stepsTimelineSrc from '../../assets/images/slide/product-steps-timeline.png';
import styles from './ProductSlideContentV5.css';

const STEPS = [
    {
        title: 'We ask',
        description: 'One specific question at a time, across the chapters of your life — including the things people rarely think to ask about.'
    },
    {
        title: 'You answer your way',
        description: 'Speak or type. A few minutes is enough, and there’s nothing to prepare.'
    },
    {
        title: 'Your chapter takes shape',
        description: 'Your answers come together in your own words, saved in one place you can return to.'
    }
];

function ProductSlideContentV5({ spriteVersion }) {
    return (
        <div className={styles.form}>
            <div className={styles.head}>
                <h1 className={styles.title}>You found a story worth telling without writing a word</h1>
                <p className={styles.description}>
                    {'That’s what '}<strong>the right question</strong>{' can do. A blank page asks you to remember everything at once. Boundly gives you one clear place to begin.'}
                </p>
            </div>
            <div className={styles.steps}>
                <img src={stepsTimelineSrc} alt='' className={styles.stepsImage} />
                <div className={styles.stepsText}>
                    {STEPS.map(step => (
                        <div key={step.title} className={styles.step}>
                            <p className={styles.stepTitle}>{step.title}</p>
                            <p className={styles.stepDescription}>{step.description}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.note}>
                <EmojiIcon name='heart-red' version={spriteVersion} className={styles.noteEmoji} />
                <p>Keep it private, or share it with someone you choose.</p>
            </div>
        </div>
    );
}

ProductSlideContentV5.propTypes = {
    spriteVersion: PropTypes.string.isRequired
};

export {
    ProductSlideContentV5
};
